import { filteredFileSelector } from 'containers/Project/FileSection/selectors'
import { 
    filteredFilesSelector as imagesSelector
} from 'containers/Project/FilePreview/selectors'

import { createSelector } from 'reselect'
import { isImageFile } from 'helpers/imageUtil'
import { FILE_TYPE } from 'containers/Project/FileUploadDialog/constants'

const thumbnailLinksSelector = state => state.project.thumbnail.links
const thumbnailLoadingSelector = state => state.project.thumbnail.loading

const thumbnailFileSelector = createSelector(
    filteredFileSelector,
    (files) =>  files.find(file => 
        file.fileType === FILE_TYPE.NVQUAL_SYSTEM_TOPOLOGY.label && isImageFile(file.name))
)

const toBeFetchedThumbnailsSelector = createSelector(
    imagesSelector,
    thumbnailLinksSelector,
    (images, alreadyFetchedThumbnails) =>  {
        const fileIds = alreadyFetchedThumbnails.map(x => x.fileId)
        return images.filter(img => !fileIds.includes(img.fileId))
    }
)

export {
    thumbnailFileSelector,
    thumbnailLinksSelector,
    thumbnailLoadingSelector,
    toBeFetchedThumbnailsSelector,
}

